import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Sorting } from '../_model/sorting.model';
import { Filter } from '../_model/filter.model';

@Injectable({
    providedIn: 'root'
})

export class RequestsService {

    constructor(private http: HttpClient) { }

    getRequests(rowsNumber: number, pageNo: number, sorting: Sorting, searchValue: string, filterValues: Filter, request_number: number) {
        let filterValuesForRolesApi = '';
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        let filterValuesForRoutesApi = '';
        if (filterValues.gates !== undefined) {
            filterValues.gates.map(gate => {
                filterValuesForRoutesApi = filterValuesForRoutesApi.concat('&filter[gate_id][]=' + gate)
            })
        }
        if (filterValues.routes !== undefined) {
            filterValues.routes.map(route => {
                filterValuesForRoutesApi = filterValuesForRoutesApi.concat('&filter[route_id][]=' + route)
            })
        }
        if (filterValues.roles !== undefined) {
            filterValues.roles.map(role => {
                filterValuesForRolesApi = filterValuesForRolesApi.concat('&filter[role][]=' + role)
            })
        }
        if (filterValues.grades !== undefined) {
            filterValues.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
            })
        }
        if (filterValues.classes !== undefined) {
            filterValues.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
            })
        }
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/waiting_requests?
        role_type=staff
        &is_paginated=1
        &per_page=${rowsNumber}
        ${sorting.name !== null ? '&sort[name]=' + sorting.name : ''}
        ${filterValues.registration !== -1 && filterValues.registration !== undefined ? '&filter[status][]=' + filterValues.registration : ''}
        ${filterValues.activation !== -1 && filterValues.activation !== undefined ? '&filter[activate][]=' + filterValues.activation : ''}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValuesForRolesApi}
        ${filterValuesForRoutesApi}
        ${searchValue === undefined || searchValue === '' ? '&page=' + pageNo : ''} 
        ${searchValue !== undefined ? '&search=' + searchValue : ''}
        &request_number=${request_number}`);
    }

    takeAction(body) {
        body["_method"] = "PUT";
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/join_request`, body);
    }

    getEditRequests(rowsNumber: number, pageNo: number,) {
        return this.http.get(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/student-edit-requests/paginate?page=${pageNo}&per_page=${rowsNumber}`);
    }

    approveEditRequest(requestId: number) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/student-edit-requests/${requestId}/approve`, null);
    }

    cancelEditRequest(requestId: number) {
        return this.http.delete(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/student-edit-requests/${requestId}`);
    }

    approveAllEditRequests() {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/student-edit-requests/approve/all`, null);
    }

    editEditRequestByAdmin(requestId: number, body) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/student-edit-requests/${requestId}`, body);
    }

    getEarlyDismissalRequests(_rowsNumber: number, _pageNo: number, searchValue: string, type?: string | null, status?: string | null, cursor?: string | null) {
        const typeParam = type ? `&type=${type}` : '';
        const statusParam = type === 'schedule'
        ? '&status[]=pending&status[]=approved&status[]=declined&status[]=delivered'
        : `&status[]=${status ?? 'pending'}`;
        const searchParam = searchValue ? `&search=${searchValue}` : '';
        const cursorParam = cursor ? `&cursor=${cursor}` : '';
        return this.http.get(
            environment.url + `school-admin/schools/${localStorage.getItem('schoolId')}/early-dismissal-requests/paginate?${cursorParam}${typeParam}${statusParam}${searchParam}`
        );
    }
    approveEarlyDismissalRequest(requestId: number) {
        return this.http.post(environment.url + `school-admin/schools/${localStorage.getItem('schoolId')}/early-dismissal-requests/${requestId}/approve`, null);
    }
    cancelEarlyDismissalRequest(requestId: number, declinedReason) {
        return this.http.post(environment.url + `school-admin/schools/${localStorage.getItem('schoolId')}/early-dismissal-requests/${requestId}/decline`, declinedReason);
    }

    deliverEarlyDismissalRequestStudent(earlyDismissalRequestId: number) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/early-dismissal-requests/${earlyDismissalRequestId}/deliver`, null);
    }
}
